
import { ErrorMessage } from "@/models/ErrorMessage";
import { Store } from "../../../store/store";
//Store the error from the call the action imply the update
//This store is malled by the page that uses the error component to update his content and define what to show 
//the "Alert" type is the closable view the "pageError" type have a buttun to return to the previus navigation
class ErrorStore extends Store {
  data() {
    return {
      type: "Alert",
      show: false,
      error: new ErrorMessage(),
    };
  }

  updateError(error) {
    if (error) {
      this.state.error = error;
      this.state.show = true;
    }
  }
  pageError(error) {
    if (error) {
      this.state.error = error;
      this.state.show = true;
      this.state.type="pageError"
    }
  }
    setRouteToGoBack(root){
    this.state.prewRoute=root
  }
  clean(){
    this.state.type="Alert"
    this.state.show = false
    this.state.error =  new ErrorMessage()
  }
}
export const errorStore = new ErrorStore("ERRORS");
